(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-info"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('[data-collection-info]');
  if (!sections.length) return;

  sections.forEach((section) => {
    if (!section.classList.contains('collection-info--collapsible')) {
      return;
    }

    const toggle = section.querySelector('[data-collection-info-toggle]');
    const body = section.querySelector('[data-collection-info-body]');

    if (!toggle || !body) {
      return;
    }

    const mediaQuery = window.matchMedia('(min-width: 750px)');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const collapsedClass = 'collection-info--collapsed';
    const expandedClass = 'collection-info--expanded';

    const setExpandedState = (expanded, skipTransition = false) => {
      if (expanded) {
        section.classList.add(expandedClass);
        section.classList.remove(collapsedClass);
        toggle.setAttribute('aria-expanded', 'true');
        body.setAttribute('aria-hidden', 'false');

        if (skipTransition || prefersReducedMotion.matches) {
          body.style.maxHeight = 'none';
          return;
        }

        body.style.maxHeight = body.scrollHeight + 'px';
        window.setTimeout(() => {
          body.style.maxHeight = 'none';
        }, 320);
      } else {
        section.classList.add(collapsedClass);
        section.classList.remove(expandedClass);
        toggle.setAttribute('aria-expanded', 'false');
        body.setAttribute('aria-hidden', 'true');

        if (skipTransition || prefersReducedMotion.matches) {
          body.style.maxHeight = '0px';
          return;
        }

        body.style.maxHeight = body.scrollHeight + 'px';
        body.offsetHeight;
        requestAnimationFrame(() => {
          body.style.maxHeight = '0px';
        });
      }
    };

    const syncToViewport = (event) => {
      const matches = event ? event.matches : mediaQuery.matches;
      if (matches) {
        setExpandedState(true, true);
      } else {
        setExpandedState(false, true);
      }
    };

    syncToViewport();

    const mediaListener = (event) => syncToViewport(event);
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', mediaListener);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(mediaListener);
    }

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      const isExpanded = section.classList.contains(expandedClass) && !section.classList.contains(collapsedClass);
      setExpandedState(!isExpanded);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const fileInputs = document.querySelectorAll('.file-upload-input');

    fileInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        const box = this.nextElementSibling;
        const feedback = box.querySelector('.file-upload-feedback');
        const files = this.files;

        if (files.length > 0) {
          box.classList.add('has-files');

          if (files.length === 1) {
            feedback.textContent = files[0].name;
          } else {
            feedback.textContent = files.length + ' files selected';
          }
        } else {
          box.classList.remove('has-files');
          feedback.textContent = '';
        }
      });
    });
  });

  (function() {
    function applyMaxWidthToSections() {
      const shopifyFormsEmbed = document.querySelector('shopify-forms-embed');
      
      if (shopifyFormsEmbed && shopifyFormsEmbed.shadowRoot) {
        const sections = shopifyFormsEmbed.shadowRoot.querySelectorAll('section');
        sections.forEach(section => {
          section.style.maxWidth = '1200px';
          section.style.margin = 'auto';
        });
      }
    }

    // Try to apply styles immediately
    applyMaxWidthToSections();

    // Set up observer to watch for the shopify-forms-embed element
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.tagName === 'SHOPIFY-FORMS-EMBED') {
              // Wait a bit for shadow DOM to be ready
              setTimeout(applyMaxWidthToSections, 100);
            }
            // Also check if shopify-forms-embed was added as a child
            const shopifyFormsEmbed = node.querySelector && node.querySelector('shopify-forms-embed');
            if (shopifyFormsEmbed) {
              setTimeout(applyMaxWidthToSections, 100);
            }
          }
        });
      });
    });

    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also try again after DOM is fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(applyMaxWidthToSections, 200);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  class FAQTabs {
    constructor(container) {
      this.container = container;
      this.tabs = container.querySelectorAll('.faq-tab');
      this.panels = container.querySelectorAll('.faq-tab-panel');
      this.accordions = container.querySelectorAll('.accordion details');

      this.init();
    }

    init() {
      this.tabs.forEach(tab => {
        // Only add click handler if it's not inside a summary (accordion toggle)
        if (!tab.closest('summary')) {
          tab.addEventListener('click', (e) => this.handleTabClick(e));
        }
      });

      this.accordions.forEach(details => {
        const summary = details.querySelector('summary');
        const content = details.querySelector('.accordion__content');

        // Set initial state
        if (!details.hasAttribute('open')) {
          gsap.set(content, { height: 0, opacity: 0 });
        } else {
          gsap.set(content, { height: 'auto', opacity: 1 });
        }

        summary.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleAccordion(details, content);
        });
      });
    }

    toggleAccordion(details, content) {
      const isOpen = details.hasAttribute('open');

      if (isOpen) {
        // Close animation
        gsap.to(content, {
          height: 0,
          opacity: 0,
          duration: 0.4,
          ease: 'power2.inOut',
          onComplete: () => {
            details.removeAttribute('open');
          }
        });
      } else {
        // Close all other accordions in the same panel
        const currentPanel = details.closest('.faq-tab-panel');
        const otherAccordions = currentPanel.querySelectorAll('.accordion details[open]');

        otherAccordions.forEach(otherDetails => {
          if (otherDetails !== details) {
            const otherContent = otherDetails.querySelector('.accordion__content');
            gsap.to(otherContent, {
              height: 0,
              opacity: 0,
              duration: 0.4,
              ease: 'power2.inOut',
              onComplete: () => {
                otherDetails.removeAttribute('open');
              }
            });
          }
        });

        // Open animation
        details.setAttribute('open', '');
        gsap.fromTo(content,
          { height: 0, opacity: 0 },
          {
            height: 'auto',
            opacity: 1,
            duration: 0.4,
            ease: 'power2.out'
          }
        );
      }
    }

    handleTabClick(e) {
      e.preventDefault();
      const clickedTab = e.currentTarget;
      const targetId = clickedTab.getAttribute('data-tab');

      // Update tabs
      this.tabs.forEach(tab => {
        if (tab === clickedTab) {
          tab.classList.add('active');
        } else {
          tab.classList.remove('active');
        }
      });

      // Get the all panel
      const allPanel = this.container.querySelector('[data-all-panel]');
      const accordions = allPanel.querySelectorAll('.accordion');
      const titles = allPanel.querySelectorAll('.faq-group-title');

      // If "All" tab is clicked, show all accordions and titles
      if (targetId === 'faq-tab-all') {
        accordions.forEach(accordion => {
          accordion.style.display = '';
        });
        titles.forEach(title => {
          title.style.display = '';
        });
      } else {
        // Extract the group handle from the targetId
        const groupHandle = targetId.replace('faq-tab-', '');

        // Show/hide accordions and titles based on their group
        accordions.forEach(accordion => {
          const accordionGroup = accordion.getAttribute('data-faq-group');
          if (accordionGroup === groupHandle) {
            accordion.style.display = '';
          } else {
            accordion.style.display = 'none';
          }
        });
        titles.forEach(title => {
          title.style.display = 'none';
        });
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const faqSections = document.querySelectorAll('.faqs');
    faqSections.forEach(section => {
      new FAQTabs(section);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const backToTopButton = document.querySelector('.footer__back-to-top');
    if (backToTopButton) {
      backToTopButton.addEventListener('click', function() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.stickyType = this.getAttribute('data-sticky-type');
      const thresholdAttr = this.getAttribute('data-sticky-threshold');
      this.stickyThresholdPercent = thresholdAttr !== null ? parseInt(thresholdAttr) : 50;
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.headerBounds = {};
      this.isOverlayHeader = this.classList.contains('header-wrapper--overlay');
      this.headerSpacer = null;
      this.isCurrentlySticky = false;

      // Check if overlay should be applied based on first section
      this.checkOverlayApplicability();

      this.setHeaderHeight();
      this.createHeaderSpacer();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.handleResize.bind(this));

      // All sticky types now respect the threshold - no auto-sticky behavior

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.handleResize.bind(this));

      this.createObserver();
    }

    checkOverlayApplicability() {
      if (!this.isOverlayHeader) return;

      // Find the first section after the header
      const mainContent = document.querySelector('#MainContent');
      if (!mainContent) return;

      const firstSection = mainContent.querySelector('.shopify-section');
      if (!firstSection) return;

      // Check if first section contains an image-banner
      const hasImageBanner = firstSection.querySelector('.banner, .image-banner, [class*="image-banner"]');

      if (!hasImageBanner) {
        // Remove overlay class if first section is not an image banner
        this.classList.remove('header-wrapper--overlay');
        this.isOverlayHeader = false;
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    createHeaderSpacer() {
      if (!this.isOverlayHeader) return;

      this.headerSpacer = document.createElement('div');
      this.headerSpacer.className = 'header-spacer';
      this.headerSpacer.style.height = '0px';
      this.headerSpacer.style.transition = 'height 0.3s ease';
      this.insertAdjacentElement('afterend', this.headerSpacer);
    }

    updateSpacerHeight() {
      if (!this.isOverlayHeader || !this.headerSpacer) return;

      const headerHeight = this.header.offsetHeight;
      if (this.isCurrentlySticky) {
        this.headerSpacer.style.height = `${headerHeight}px`;
      } else {
        this.headerSpacer.style.height = '0px';
      }
    }

    handleResize() {
      this.setHeaderHeight();
      this.updateSpacerHeight();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.handleResize.bind(this));
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const stickyThreshold = window.innerHeight * (this.stickyThresholdPercent / 100);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Check if we're below the threshold
      const belowThreshold = scrollTop < stickyThreshold;

      // If below threshold, reset and exit early
      if (belowThreshold) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
        this.currentScrollTop = scrollTop;
        return;
      }

      // Above threshold - apply sticky behavior based on type
      if (this.headerIsAlwaysSticky) {
        // For "always" and "reduce-logo-size" types
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.makeSticky.bind(this));
      } else {
        // For "on-scroll-up" type, use existing scroll direction logic
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) {
            this.currentScrollTop = scrollTop;
            return;
          }
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    makeSticky() {
      this.isCurrentlySticky = true;
      this.header.classList.add('shopify-section-header-sticky');
      this.updateSpacerHeight();
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.isCurrentlySticky = true;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.updateSpacerHeight();
    }

    reset() {
      this.isCurrentlySticky = false;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.updateSpacerHeight();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
      const COLLAPSED_HEIGHT = 300;
      const containers = Array.from(document.querySelectorAll('[data-collection-info]'));
      if (!containers.length) return;

      const mediaQuery = window.matchMedia('(max-width: 749px)');
      const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const hasGSAP = typeof gsap !== 'undefined';

      const animateHeight = (element, targetHeight, { duration = 0.4, ease = 'power2.out' } = {}) => {
        if (!hasGSAP || reduceMotionQuery.matches) {
          element.style.height = targetHeight === 'auto' ? 'auto' : `${targetHeight}px`;
          return;
        }

        const currentHeight = element.offsetHeight;
        const destination = targetHeight === 'auto' ? element.scrollHeight : targetHeight;

        if (currentHeight === destination) {
          element.style.height = targetHeight === 'auto' ? 'auto' : `${targetHeight}px`;
          return;
        }

        gsap.fromTo(
          element,
          { height: currentHeight },
          {
            height: destination,
            duration,
            ease,
            onComplete: () => {
              element.style.height = targetHeight === 'auto' ? 'auto' : `${targetHeight}px`;
            }
          }
        );
      };

      const applyBreakpointFallback = (callback) => {
        if (typeof mediaQuery.addEventListener === 'function') {
          mediaQuery.addEventListener('change', callback);
        } else if (typeof mediaQuery.addListener === 'function') {
          mediaQuery.addListener(callback);
        }
      };

      containers.forEach((container) => {
        const content = container.querySelector('[data-collection-info-content]');
        const toggle = container.querySelector('[data-collection-info-toggle]');
        if (!content || !toggle) return;

        const collapse = () => {
          container.classList.add('collection-info--collapsed');
          container.classList.remove('collection-info--expanded');
          toggle.setAttribute('aria-expanded', 'false');

          if (!mediaQuery.matches) {
            content.style.height = '';
            return;
          }

          animateHeight(content, COLLAPSED_HEIGHT, { ease: 'power2.inOut' });
        };

        const expand = () => {
          container.classList.add('collection-info--expanded');
          container.classList.remove('collection-info--collapsed');
          toggle.setAttribute('aria-expanded', 'true');

          if (!mediaQuery.matches) {
            content.style.height = '';
            return;
          }

          animateHeight(content, 'auto');
        };

        const updateState = () => {
          const shouldCollapse = mediaQuery.matches && content.scrollHeight > COLLAPSED_HEIGHT;

          if (!shouldCollapse) {
            container.classList.remove('collection-info--collapsible', 'collection-info--collapsed', 'collection-info--expanded');
            toggle.hidden = true;
            toggle.setAttribute('aria-expanded', 'false');
            content.style.height = '';
            return;
          }

          container.classList.add('collection-info--collapsible');
          toggle.hidden = false;

          if (container.classList.contains('collection-info--expanded')) {
            content.style.height = mediaQuery.matches ? 'auto' : '';
            toggle.setAttribute('aria-expanded', 'true');
          } else {
            container.classList.add('collection-info--collapsed');
            container.classList.remove('collection-info--expanded');
            toggle.setAttribute('aria-expanded', 'false');
            content.style.height = mediaQuery.matches ? `${COLLAPSED_HEIGHT}px` : '';
          }
        };

        toggle.addEventListener('click', (event) => {
          event.preventDefault();

          if (container.classList.contains('collection-info--expanded')) {
            collapse();
          } else {
            expand();
          }
        });

        updateState();
        applyBreakpointFallback(updateState);
        window.addEventListener('resize', updateState);
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cooking-guides"] && !Shopify.designMode) return;
  try {
    
  class CookingGuideTabs {
    constructor(container) {
      this.container = container;
      this.tabs = container.querySelectorAll('.cooking-tab');
      this.panels = container.querySelectorAll('.cooking-tab-panel');
      this.images = container.querySelectorAll('.cooking-guides__image');
      this.productImage = container.querySelector('[data-image-type="product"]');
      
      // Dropdown elements
      this.dropdown = container.querySelector('.cooking-guides__dropdown');
      if (this.dropdown) {
        this.dropdownButton = this.dropdown.querySelector('.cooking-guides__dropdown-button');
        this.dropdownMenu = this.dropdown.querySelector('.cooking-guides__dropdown-menu');
        this.dropdownText = this.dropdown.querySelector('.cooking-guides__dropdown-text');
        this.dropdownItems = this.dropdown.querySelectorAll('.cooking-guides__dropdown-item');
      }

      this.init();
    }

    init() {
      // Desktop tabs
      this.tabs.forEach(tab => {
        tab.addEventListener('click', (e) => this.handleTabClick(e));
      });

      // Mobile dropdown
      if (this.dropdown) {
        this.dropdownButton.addEventListener('click', () => this.toggleDropdown());
        
        this.dropdownItems.forEach(item => {
          item.addEventListener('click', (e) => this.handleDropdownItemClick(e));
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
          if (!this.dropdown.contains(e.target)) {
            this.closeDropdown();
          }
        });
      }
    }

    toggleDropdown() {
      const isExpanded = this.dropdownButton.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    }

    openDropdown() {
      this.dropdownButton.setAttribute('aria-expanded', 'true');
      this.dropdown.classList.add('is-open');
    }

    closeDropdown() {
      this.dropdownButton.setAttribute('aria-expanded', 'false');
      this.dropdown.classList.remove('is-open');
    }

    handleDropdownItemClick(e) {
      const item = e.currentTarget;
      const targetId = item.getAttribute('data-tab');
      const index = item.getAttribute('data-index');
      const label = item.getAttribute('data-label');

      // Update dropdown selection
      this.dropdownItems.forEach(dropdownItem => {
        dropdownItem.classList.remove('is-selected');
      });
      item.classList.add('is-selected');

      // Update dropdown text
      const formattedIndex = index.toString().padStart(2, '0');
      this.dropdownText.textContent = `${formattedIndex} ${label}`;

      // Close dropdown
      this.closeDropdown();

      // Switch content
      this.switchToTab(targetId, parseInt(index));
    }

    handleTabClick(e) {
      e.preventDefault();
      const clickedTab = e.currentTarget;
      const targetId = clickedTab.getAttribute('data-tab');
      const tabIndex = Array.from(this.tabs).indexOf(clickedTab) + 1;

      // Update tabs
      this.tabs.forEach(tab => {
        if (tab === clickedTab) {
          tab.classList.add('active');
        } else {
          tab.classList.remove('active');
        }
      });

      this.switchToTab(targetId, tabIndex);
    }

    switchToTab(targetId, tabIndex) {
      // Remove active class from all panels and images
      this.panels.forEach(panel => panel.classList.remove('active'));
      this.images.forEach(image => image.classList.remove('active'));

      // Add active class to corresponding panel
      const targetPanel = this.container.querySelector(`#${targetId}`);
      if (targetPanel) {
        targetPanel.classList.add('active');
      }

      // Update desktop tabs to match (in case triggered from mobile dropdown)
      this.tabs.forEach((tab, index) => {
        if (index + 1 === tabIndex) {
          tab.classList.add('active');
        } else {
          tab.classList.remove('active');
        }
      });

      // Image switching logic with fallbacks
      this.switchToImage(tabIndex);
    }

    switchToImage(methodIndex) {
      // Priority 1: Look for method-specific image
      const methodImage = this.container.querySelector(`[data-method-index="${methodIndex}"]`);
      if (methodImage) {
        methodImage.classList.add('active');
        return;
      }

      // Priority 2: Fall back to product image if available
      if (this.productImage) {
        this.productImage.classList.add('active');
        return;
      }

      // Priority 3: If no product image, keep the currently active image
      const currentActive = this.container.querySelector('.cooking-guides__image.active');
      if (currentActive) {
        currentActive.classList.add('active');
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const cookingGuides = document.querySelectorAll('.cooking-guides');
    cookingGuides.forEach(guide => {
      new CookingGuideTabs(guide);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team"] && !Shopify.designMode) return;
  try {
    
  class TeamModal {
    constructor() {
      this.modal = document.getElementById('team-modal');
      this.modalImage = document.getElementById('modal-image');
      this.modalName = document.getElementById('modal-name');
      this.modalRole = document.getElementById('modal-role');
      this.modalDescription = document.getElementById('modal-description');
      
      const dataElement = document.getElementById('team-members-data');
      this.teamMembers = dataElement ? JSON.parse(dataElement.textContent) : [];
      
      this.init();
    }

    init() {
      const triggers = document.querySelectorAll('[data-member-id]');
      const closeButtons = document.querySelectorAll('[data-modal-close]');

      triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          const memberId = trigger.getAttribute('data-member-id');
          this.openModal(memberId);
        });
      });

      closeButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.closeModal();
        });
      });

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const isOpen = this.modal && this.modal.getAttribute('aria-hidden') === 'false';
          if (isOpen) this.closeModal();
        }
      });

      // Close when clicking the modal itself (but not the content)
      if (this.modal) {
        this.modal.addEventListener('click', (e) => {
          if (e.target === this.modal || e.target.hasAttribute('data-modal-close')) {
            this.closeModal();
          }
        });
      }
    }

    openModal(memberId) {
      const member = this.teamMembers.find(m => m.id === String(memberId));
      if (!member || !this.modal) return;

      // Populate modal content
      if (this.modalName) {
        this.modalName.innerHTML = member.fullName;
      }
      
      if (this.modalRole) {
        this.modalRole.innerHTML = member.role;
      }

      // Handle contact info (phone and email without icons)
      const contactWrapper = document.getElementById('modal-contact-wrapper');
      const contactContainer = document.getElementById('modal-contact');
      
      if (contactContainer && contactWrapper) {
        let contactHTML = '';
        let hasContact = false;
        
        // Add phone link if available
        if (member.phone && member.phone.trim() !== '') {
          hasContact = true;
          const phoneHref = 'tel:' + member.phone.replace(/\s/g, '');
          contactHTML += `
            <a href="${phoneHref}" class="team__modal-contact-item">
              <span class="team__modal-contact-label">Call:</span>
              <span class="team__modal-contact-text">${member.phone}</span>
            </a>
          `;
        }
        
        // Add email link if available
        if (member.email && member.email.trim() !== '') {
          hasContact = true;
          const emailHref = 'mailto:' + member.email;
          contactHTML += `
            <a href="${emailHref}" class="team__modal-contact-item">
              <span class="team__modal-contact-label">Email:</span>
              <span class="team__modal-contact-text">${member.email}</span>
            </a>
          `;
        }
        
        // Show/hide contact section based on whether there's contact info
        if (hasContact) {
          contactContainer.innerHTML = contactHTML;
          contactWrapper.style.display = 'block';
        } else {
          contactWrapper.style.display = 'none';
        }
      }
      
      if (this.modalDescription) {
        this.modalDescription.innerHTML = member.description;
      }

      // Show modal
      this.modal.setAttribute('aria-hidden', 'false');
      
      // Stop Lenis scroll
      if (window.lenis) {
        window.lenis.stop();
      }
      
      // Fallback for standard scroll
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    closeModal() {
      if (!this.modal) return;

      this.modal.setAttribute('aria-hidden', 'true');
      
      // Resume Lenis scroll
      if (window.lenis) {
        window.lenis.start();
      }
      
      // Restore standard scroll
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new TeamModal());
  } else {
    new TeamModal();
  }

  } catch(e) { console.error(e); }
})();
})();
